// extracted by mini-css-extract-plugin
module.exports = {"aside":"Aside_aside__5TwMo","scale":"Aside_scale__5Q7CA","visible":"Aside_visible__dVWsK"};